// @flow
import React from 'react'
import { withProps, compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import localHistory from '../../modules/localHistory'

type CrumbProps = {
  crumb: {
    linkUrl: string,
    linkText: string,
    className?: string
  },
  onHandleClick: string => () => void
}

const Crumb = ({ crumb, onHandleClick }: CrumbProps) => {
  let classNames = 'breadcrumb'
  if (crumb.className) classNames += ` ${crumb.className}`
  return (
    <li className={classNames}>
      <a onClick={onHandleClick(crumb.linkUrl)}>
        {crumb.linkText || 'Missing linkText property in `crumbs`'}
      </a>
    </li>
  )
}

const withHandlerClick = withProps(props => ({
  onHandleClick: (linkUrl = '/explore') => e => {
    e.preventDefault()
    const twoPreviousLocationUrl =
      localHistory.previousLocation(2).pathname || ''
    if (twoPreviousLocationUrl === linkUrl) {
      props.history.goBack()
    }
    props.history.replace(linkUrl)
  }
}))

const Enhancer = compose(withRouter, withHandlerClick)

export default Enhancer(Crumb)



// WEBPACK FOOTER //
// ./src/ui/lists/crumb.js